/* Built In Imports */

/* External Imports */
import { Box, Image, Link, Text } from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import ShareIcon from '@ihs/components/Icons/ShareIcon';
import {
  ArticleIcon,
  AudioIcon,
  VideoIcon,
} from '@ihs/components/Icons/wisdomCardIcon';

/* Services */
/* Styles */

/**
 * Renders the SimpleWisdom Card component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} SimpleWisdom Card component
 */

const SimpleWisdomCard = ({ sectionContent }) => {
  // setting icon for cards
  const iconToShow = {
    article: <ArticleIcon />,
    audio: <AudioIcon />,
    video: <VideoIcon />,
  };
  const date = new Date(Date(sectionContent.childrens[0].createdAt));
  const content = sectionContent?.childrens?.[0];
  return (
    <Box
      display="flex"
      gridGap="28px"
      w={{ base: '100%', sm: '319px' }}
      mb={{ base: '20px', md: '30px' }}
      h="419px"
      flexWrap="wrap"
      mx={{ base: 'auto', md: '0' }}
    >
      <Box
        key={nanoid()}
        display="flex"
        flexDir="column"
        justifyContent="flex-start"
        flexWrap="wrap"
        w={{ base: '100%', sm: '319px' }}
        maxW={{ base: '325px', sm: '319px' }}
        bgColor="#E5EDEE"
        borderRadius="8px"
      >
        {/* <NextLink href={`/isha-home-school/wisdom/${sectionContent?.childrens[0]?.urlAlias[0].value}`} passHref legacyBehavior> */}
        <Link
          href={`/isha-home-school/wisdom/${content?.urlAlias[0].value}`}
          _hover={{ textDecor: 'none' }}
          _focus={{ boxShadow: 'none' }}
          _active={{ boxShadow: 'none' }}
        >
          <Image
            alignSelf="self-start"
            src={content?.heroImage[0]?.value?.url}
            alt={
              content?.heroImage[0]?.value?.alt ||
              content?.heroImage[0]?.value?.title
            }
            objectFit="cover"
            w="100%"
            height="180px"
            borderRadius="8px 8px 0px 0px"
          />
        </Link>
        {/* </NextLink> */}
        <Box px="24px" pb="8px">
          <Box pb="10.74px">
            {/* {iconToShow[sectionContent?.parentContent?.title]} */}
            {iconToShow[sectionContent?.parentContent?.title.toLowerCase()]}
          </Box>
          <Box
            fontSize="20px"
            color="#032B43"
            fontWeight="700"
            display="flex"
            justifyContent="space-between"
          >
            {/* <NextLink href={`/isha-home-school/wisdom/${sectionContent?.childrens[0]?.urlAlias[0].value}`} passHref legacyBehavior> */}
            <Link
              href={`/isha-home-school/wisdom/${content?.urlAlias[0].value}`}
              textDecor="none"
              _hover={{ textDecor: 'none' }}
              _focus={{ boxShadow: 'none' }}
              _active={{ boxShadow: 'none' }}
              noOfLines="2"
              lineHeight="21.331px"
            >
              {sectionContent?.childrens[0]?.title[0]?.value}
            </Link>
            {/* </NextLink> */}
            <Box>
              <ShareIcon
                url={`/isha-home-school/wisdom/${content?.urlAlias[0].value}`}
              />
            </Box>
          </Box>
          {/* <NextLink href={`/isha-home-school/wisdom/${sectionContent?.childrens[0]?.urlAlias[0].value}`} passHref legacyBehavior> */}
          <Link
            href={`/isha-home-school/wisdom/${content?.urlAlias[0].value}`}
            textDecor="none"
            _hover={{ textDecor: 'none' }}
            _focus={{ boxShadow: 'none' }}
            _active={{ boxShadow: 'none' }}
          >
            {content?.summary[0]?.value?.length && (
              <Text
                pt="17.61px"
                color="#3B444B"
                fontSize="14px"
                fontWeight="400"
                fontFamily="Zilla Slab"
                lineHeight="20.2px"
                noOfLines={3}
              >
                {content?.summary[0]?.value}
              </Text>
            )}
            {sectionContent?.descriptionText?.length && (
              <Text py="14px" fontWeight="500" color="#3B444B" noOfLines={3}>
                {sectionContent?.descriptionText}
              </Text>
            )}
          </Link>
          {/* </NextLink> */}
          <Text
            color="#3B444B"
            pt="14.36px"
            fontFamily="Zilla Slab"
            fontSize="14px"
            fontStyle="normal"
            fontWeight="600"
            lineHeight="20.285px"
          >
            {`${date.getDate()} ${date.toLocaleString('default', {
              month: 'short',
            })} ${date.getFullYear()}`}
            {sectionContent?.childrens[0]?.videoLength[0].value
              ? ` | ${content?.videoLength[0].value}`
              : ''}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default SimpleWisdomCard;
